import { BlockComponentModel } from '@/cms/types/blok-component';

import Badge, { BadgeProps, ColorOption } from '.';

type StrapiColor = ColorOption | 'info';

export interface BadgeStrapiProps {
  text: string;
  color?: StrapiColor;
  variant?: BadgeProps['variant'];
  size?: BadgeProps['size'];
}

const legacyStrapiColorMap: Partial<Record<StrapiColor, ColorOption>> = {
  info: 'secondary',
};

export default function BadgeStrapi({
  block,
  inner,
}: BlockComponentModel<BadgeStrapiProps, BadgeProps>) {
  const { text, variant, color, size } = block;

  const resolvedColor: ColorOption | undefined = color
    ? legacyStrapiColorMap[color] ?? (color as ColorOption)
    : undefined;

  return (
    <Badge variant={variant} color={resolvedColor} size={size} {...inner}>
      {text}
    </Badge>
  );
}
